import { type ReactNode } from "react";

import { MenuItem } from "@skilitics/designer-ui-components";

import { useManagedSlotPasteClipboard } from "../../../slots";
import type { DesignerNode } from "../../../types";

interface Props {
  node: DesignerNode;
  children: ReactNode;
}

export const PasteReplaceMenuItem = ({ node, children }: Props) => {
  const { paste, canPasteHere } = useManagedSlotPasteClipboard({
    target: { slotResidentNodeId: node.id },
    criteria: { typeId: node.typeId },
  });
  return (
    <MenuItem onClick={() => paste()} disabled={!canPasteHere.value}>
      {children}
    </MenuItem>
  );
};
